import React,{useEffect,useState} from 'react';
import {staffApi} from '@/lib/staffApi';
import {groupServices} from '@/lib/serviceGroups';

export function CampaignTreatmentSelect({value,onChange,disabled}) {
 const [options,setOptions]=useState([]),[status,setStatus]=useState('loading');
 const load=()=>{setStatus('loading');Promise.all([staffApi.services(),staffApi.catalogue()]).then(([data,catalogue])=>{
  setOptions(groupServices(data.services||[],catalogue.rules||{}).map(g=>g.parent).sort((a,b)=>a.name.localeCompare(b.name)));setStatus('ready');
 }).catch(()=>setStatus('error'));};
 useEffect(()=>{load();},[]);
 return <div><select aria-label="Treatment" className="block w-full mt-1 rounded-lg p-3 bg-white text-navy" disabled={disabled||status!=='ready'} value={value||''} onChange={e=>onChange(e.target.value)}>
 <option value="">{status==='loading'?'Loading services…':'Choose a service'}</option>
 {value&&!options.some(s=>s.name===value)&&<option value={value}>{value} (saved selection)</option>}
 {options.map(s=><option key={s.id} value={s.name}>{s.name}</option>)}
 </select>{status==='error'&&<p role="alert">Could not load services. <button type="button" onClick={load} className="text-gold underline">Try again</button></p>}</div>;
}
